// Aceleres: cálculo de posição do popup de menu de contexto (chevron), sem
// depender de nenhum estado de componente — usado por Message.vue (menu da
// bolha) e StickerAlbum.vue (menu de cada sticker do par). Extraído daqui
// pra não duplicar entre os dois.

export function findBubble(e) {
  const container =
    e.target?.closest?.('.message-bubble-container') ||
    e.currentTarget?.closest?.('.message-bubble-container');
  if (!container) return null;
  return container.querySelector('.right-bubble, .left-bubble');
}

export function findContextMenuTrigger(e) {
  const currentTarget = e?.currentTarget;
  if (currentTarget?.classList?.contains('aceleres-bubble-chevron')) {
    return currentTarget;
  }

  return e?.target?.closest?.('.aceleres-bubble-chevron') || null;
}

export function getDashboardZoom() {
  const zoom = parseFloat(getComputedStyle(document.documentElement).zoom);
  return Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
}

export function getVisualViewportSize() {
  const zoom = getDashboardZoom();
  const viewport = window.visualViewport;

  // As dimensões do layout ainda estão antes do zoom global do dashboard.
  // As coordenadas dos DOMRects, porém, já são visuais. Mantemos os dois na
  // mesma escala para que um popup não seja liberado para fora da tela.
  return {
    zoom,
    width: (viewport?.width || window.innerWidth) * zoom,
    height: (viewport?.height || window.innerHeight) * zoom,
  };
}

export function fixedPosition(value, zoom = getDashboardZoom()) {
  return `${value / zoom}px`;
}

export function computeMenuAnchor(e, opts = {}) {
  const cx = typeof e.clientX === 'number' ? e.clientX : 0;
  const cy = typeof e.clientY === 'number' ? e.clientY : 0;
  const POPUP_W = 310;
  const POPUP_H = 340;
  const OFFSET = typeof opts.offset === 'number' ? opts.offset : 4;
  const PAD = 8;
  const {
    zoom,
    width: viewportWidth,
    height: viewportHeight,
  } = getVisualViewportSize();

  // Aceleres 2026-07-01: usa o container scrollável da MessagesView
  // (`.scrollbar-thin.flex-grow.h-full` — o wrapper flex-col do
  // MessagesView.vue) como boundary pra decidir up/down do popup.
  // Assim garantimos que o emoji picker / menu SEMPRE nasce dentro
  // dessa área — nunca embaixo do header nem embaixo da reply-box.
  const messagesArea = document.querySelector(
    '.flex.flex-col.justify-between.flex-grow.h-full.min-w-0.m-0.scrollbar-thin'
  );
  const areaRect = messagesArea ? messagesArea.getBoundingClientRect() : null;
  const areaTop = areaRect ? areaRect.top : 0;
  const areaBottom = areaRect ? areaRect.bottom : viewportHeight;

  const bubble = findBubble(e);
  const trigger = findContextMenuTrigger(e);
  const anchor = opts.anchor || trigger || opts.verticalAnchor || bubble;
  const anchorRect = anchor?.getBoundingClientRect();
  const anchorCenterX = anchorRect
    ? anchorRect.left + anchorRect.width / 2
    : cx;
  const desiredLeft = anchorRect
    ? anchorRect.left + anchorRect.width - POPUP_W
    : anchorCenterX - POPUP_W / 2;
  const leftPx = Math.min(
    Math.max(desiredLeft, PAD),
    Math.max(PAD, viewportWidth - POPUP_W - PAD)
  );

  // Vertical: usa bounds do container em vez de window.innerHeight.
  const verticalAnchor = anchor;
  const anchorTop = verticalAnchor
    ? verticalAnchor.getBoundingClientRect().top
    : cy;
  const anchorBottom = verticalAnchor
    ? verticalAnchor.getBoundingClientRect().bottom
    : cy;

  let topPx = null;
  let bottomPx = null;
  let direction;
  const spaceBelow = areaBottom - anchorBottom;
  const spaceAbove = anchorTop - areaTop;
  const needed = POPUP_H + OFFSET + PAD;
  const fitsAbove = spaceAbove >= needed;
  const fitsBelow = spaceBelow >= needed;
  if (fitsBelow && !fitsAbove) {
    direction = 'down';
    topPx = anchorBottom + OFFSET;
  } else if (fitsAbove && !fitsBelow) {
    direction = 'up';
    bottomPx = viewportHeight - anchorTop + OFFSET;
  } else if (spaceBelow >= spaceAbove) {
    direction = 'down';
    topPx = anchorBottom + OFFSET;
  } else {
    direction = 'up';
    bottomPx = viewportHeight - anchorTop + OFFSET;
  }

  const originY = direction === 'down' ? 'top' : 'bottom';

  return {
    left: fixedPosition(leftPx, zoom),
    right: 'auto',
    top: topPx === null ? '' : fixedPosition(topPx, zoom),
    bottom: bottomPx === null ? '' : fixedPosition(bottomPx, zoom),
    direction,
    transformOrigin: `${originY} center`,
    anchorLeft: anchorRect?.left ?? cx,
    anchorTop,
    anchorRight: anchorRect?.right ?? cx,
    anchorBottom: anchorRect?.bottom ?? cy,
    anchorWidth: anchorRect?.width ?? 0,
    anchorHeight: anchorRect?.height ?? 0,
  };
}
